export default __webpack_public_path__ + "static/media/rounded-circle-phone.af47a202.svg";